"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* eslint-disable max-len */

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    cls1: {
      isolation: 'isolate'
    },
    cls2: {
      fill: theme.palette.secondary.mainDark
    },
    cls3: {
      fill: theme.palette.primary.main
    }
  };
});
var ContactUsIcon = function ContactUsIcon() {
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "125",
    height: "45",
    viewBox: "0 0 125 45",
    className: classes.contactUsSvg,
    "aria-label": "24 7",
    role: "img"
  }, /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("g", {
    id: "_24_7",
    className: classes.cls1
  }, /*#__PURE__*/_react.default.createElement("g", {
    className: classes.cls1
  }, /*#__PURE__*/_react.default.createElement("path", {
    className: classes.cls2,
    d: "M71.77,28.52v4.85H53.5a12.64,12.64,0,0,1,1.78-5.21,34.58,34.58,0,0,1,5.86-6.52,37.92,37.92,0,0,0,4.33-4.45A5.79,5.79,0,0,0,66.54,14a3.63,3.63,0,0,0-.94-2.69,4,4,0,0,0-5.18,0,5,5,0,0,0-1.11,3.27l-5.2-.52q.47-4.3,2.91-6.18a9.81,9.81,0,0,1,6.13-1.88,8.82,8.82,0,0,1,6.32,2.18,7.07,7.07,0,0,1,2.3,5.39,9.54,9.54,0,0,1-.65,3.5A14.25,14.25,0,0,1,69,20.6a32.53,32.53,0,0,1-3.42,3.47q-2.46,2.26-3.12,3a8.62,8.62,0,0,0-1.07,1.44Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    className: classes.cls2,
    d: "M85.52,33.37V27.89H74.39V23.33L86.19,6.05h4.38V23.31H94v4.58H90.57v5.48Zm0-10.06V14l-6.25,9.3Z"
  })), /*#__PURE__*/_react.default.createElement("g", {
    className: classes.cls1
  }, /*#__PURE__*/_react.default.createElement("path", {
    className: classes.cls3,
    d: "M94.76,33.83,101.5,5.7h3.91L98.6,33.83Z"
  })), /*#__PURE__*/_react.default.createElement("g", {
    className: classes.cls1
  }, /*#__PURE__*/_react.default.createElement("path", {
    className: classes.cls2,
    d: "M107,11.38V6.54h17.83v3.78a28.17,28.17,0,0,0-4.49,6.24,36.46,36.46,0,0,0-3.48,8.63,32.1,32.1,0,0,0-1.18,8.18h-5A35,35,0,0,1,113,21.86a38.41,38.41,0,0,1,5.88-10.48Z"
  }))), /*#__PURE__*/_react.default.createElement("g", {
    id: "phone"
  }, /*#__PURE__*/_react.default.createElement("path", {
    id: "Path_2396",
    className: classes.cls3,
    d: "M29.88,29.48l-6-1.8a2.07,2.07,0,0,0-2.1.53L21,29a1.89,1.89,0,0,1-2.37.27,22.34,22.34,0,0,1-4-3.18A21.94,21.94,0,0,1,11,21.21a1.89,1.89,0,0,1,.32-2.3l.68-.68A2.09,2.09,0,0,0,12.47,16L10.41,10a3.59,3.59,0,0,0-2.63-2.4C5.64,7,4.17,8.63,3,9.9c-.21.23-.43.44-.62.66A7.27,7.27,0,0,0,.52,18,33.62,33.62,0,0,0,9,31.67a34,34,0,0,0,12.52,8.06,7.75,7.75,0,0,0,2.65.47A6.72,6.72,0,0,0,29.23,38c.24-.26.5-.53.76-.79,1.32-1.36,3-3,2.36-5.19A3.59,3.59,0,0,0,29.88,29.48Zm-.77,6.86c-.28.28-.55.56-.79.82a5.79,5.79,0,0,1-6.39,1.43A32.81,32.81,0,0,1,9.86,30.82,32.47,32.47,0,0,1,1.7,17.58a6,6,0,0,1,1.52-6.15c.22-.22.43-.43.65-.68A9.58,9.58,0,0,1,4.56,10l2.93,6.6,1.12-.5L5.54,9.2a2.38,2.38,0,0,1,2-.44,2.3,2.3,0,0,1,1.72,1.58l2.05,6.09a.87.87,0,0,1-.21.93L10.4,18a3.13,3.13,0,0,0-.52,3.76,23.53,23.53,0,0,0,3.88,5.11A23.74,23.74,0,0,0,18,30.27a3.13,3.13,0,0,0,3.88-.44l.75-.76a.88.88,0,0,1,.9-.23l6,1.81a2.36,2.36,0,0,1,1.65,1.67,2.2,2.2,0,0,1,0,1.32L24,31.94l-.27,1.18,6.83,1.64A15.14,15.14,0,0,1,29.11,36.34Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Path_2397",
    className: classes.cls3,
    d: "M28.37,6.71a9,9,0,0,0-9,9A8.84,8.84,0,0,0,20.45,20L17,25.78l7.43-2a9,9,0,1,0,4-17.07Zm0,16.75a7.53,7.53,0,0,1-3.6-.86l-.22-.11L19.61,23.8,21.89,20l-.19-.32a7.79,7.79,0,1,1,6.69,3.81Z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    id: "Path_2398",
    className: classes.cls3,
    d: "M16.12,23.42l2.19-4.26h0A9.29,9.29,0,0,1,22.4,6.69,9.69,9.69,0,0,1,24.28,6L24,4.8a10.5,10.5,0,0,0-7.56,12.78,10.21,10.21,0,0,0,.52,1.53L15,22.84Z"
  }))));
};
var _default = exports.default = ContactUsIcon;